var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCritical12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/critical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 5.99999C11.3999 8.98233 8.98224 11.4 5.9999 11.4C3.01756 11.4 0.599902 8.98233 0.599902 5.99999C0.599902 3.01766 3.01756 0.599994 5.9999 0.599994C8.98224 0.599994 11.3999 3.01766 11.3999 5.99999Z",
    fill: "#EB0042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99989 7.19999C5.88054 7.19999 5.76608 7.1487 5.68169 7.05739C5.5973 6.96609 5.54989 6.84225 5.54989 6.71313L5.54989 3.48686C5.54989 3.35773 5.5973 3.2339 5.68169 3.14259C5.76608 3.05129 5.88054 2.99999 5.99989 2.99999C6.11924 2.99999 6.2337 3.05129 6.31809 3.14259C6.40248 3.2339 6.44989 3.35773 6.44989 3.48686V6.71313C6.44989 6.84225 6.40248 6.96609 6.31809 7.05739C6.2337 7.1487 6.11924 7.19999 5.99989 7.19999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99989 8.09999C5.66852 8.09999 5.39989 8.36862 5.39989 8.69999C5.39989 9.03136 5.66852 9.29999 5.99989 9.29999C6.33126 9.29999 6.59989 9.03136 6.59989 8.69999C6.59989 8.36862 6.33126 8.09999 5.99989 8.09999Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical12);
export default __webpack_public_path__ + "static/media/critical_12.33b970a556673a61dd0541a719140a6c.svg";
export { ForwardRef as ReactComponent };